import { QueryClient } from '@tanstack/react-query';
import { LoaderFunctionArgs } from 'react-router';
import { SystemPermission_Permission } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { listSystemEventsQuery } from '~/pages/SystemAdmin/api/system-events.queries';
import { SystemEventListModel } from '~/pages/SystemAdmin/models/SystemEventListModel';
import { getSystemQuery } from '~/shared/api/system.queries';
import { requireUserPermissionForSystemId } from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';

export type SystemAdminLoaderData = {
  events: SystemEventListModel;
};

export const systemAdminLoader =
  (queryClient: QueryClient) =>
  async ({
    params,
    request,
  }: LoaderFunctionArgs): Promise<SystemAdminLoaderData | Response> => {
    const { systemId } = params;

    assertIsDefined(systemId);

    await requireUserPermissionForSystemId(
      queryClient,
      request,
      SystemPermission_Permission.COMMISSIONING,
      systemId,
    );

    const system = await queryClient.ensureQueryData(getSystemQuery(systemId));

    const events = await queryClient.ensureQueryData(
      listSystemEventsQuery({
        resourceName: system.name,
      }),
    );

    return { events };
  };
